import { api } from '$utils/apiRequester'

/**
 * id : project id
 * action : like or unlike
 */
export const updateUserRole = (id = '', action = '', projectUrl) => {
  const endpoint = `/projects/${id}/${action}`

  return api('ulule')
    .post(endpoint, {
      withAccessToken: true,
      body: {},
    })
    .then((resp) => {
      return new Promise((resolve) => {
        resolve({ success: true, action })
      })
    })
    .catch((error) => {
      saveAction(id, action)
      throw error
    })
}

export const getChannels = (lang, country) => {
  const endpoint = `/channels?limit=6&${lang ? `lang=${lang}&` : ''}${country ? `country=${country}` : ''}`

  return api('ulule')
    .get(endpoint)
    .then((resp) => {
      return new Promise((resolve) => {
        resolve({ success: true, ...resp })
      })
    })
    .catch((error) => {
      throw error
    })
}

export const saveAction = (id, action) => {
  sessionStorage.setItem('lastAction', JSON.stringify({ id, action }))
}

export const replayLastAction = () => {
  const entry = sessionStorage.getItem('lastAction')
  if (entry) {
    sessionStorage.removeItem('lastAction')
    const { id, action } = JSON.parse(entry)
    return updateUserRole(id, action)
  }
}
